export default __webpack_public_path__ + "static/media/kitchen3-afterG-768w.30e0a3de.png";